import React, { ReactNode } from 'react';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';

interface ProtectedContentProps {
  children: ReactNode;
  hasAccess: boolean;
  featureName?: string;
  onUpgrade?: () => void;
}

const ProtectedContent: React.FC<ProtectedContentProps> = ({
  children,
  hasAccess,
  featureName = 'Bu özellik',
  onUpgrade
}) => {
  if (hasAccess) {
    return <>{children}</>;
  }

  return (
    <div className="relative">
      {/* Blurred Content */}
      <div className="blur-md pointer-events-none select-none opacity-50">
        {children}
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 flex items-center justify-center bg-[#0a0a14]/80 backdrop-blur-sm rounded-2xl">
        <div className="text-center p-8 max-w-md">
          <div className="w-16 h-16 rounded-2xl bg-purple-500/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-purple-400" />
          </div>

          <h3 className="text-xl font-bold text-white mb-2">
            Abonelik Gerekli
          </h3>

          <p className="text-gray-400 mb-6">
            {featureName} için aktif bir aboneliğe ihtiyacınız var.
            30 günlük ücretsiz deneme süreniz sona erdi.
          </p>

          <button
            onClick={onUpgrade}
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-xl font-medium hover:opacity-90 transition-opacity"
          >
            <Sparkles className="w-5 h-5" />
            Premium'a Yükselt
            <ArrowRight className="w-4 h-4" />
          </button>

          <p className="text-xs text-gray-500 mt-4">
            Aylık $14.90'dan başlayan fiyatlarla
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProtectedContent;
